import { render, staticRenderFns } from "./SubLicenseList.vue?vue&type=template&id=d1c2ac84"
import script from "./SubLicenseList.vue?vue&type=script&lang=js"
export * from "./SubLicenseList.vue?vue&type=script&lang=js"
import style0 from "./SubLicenseList.vue?vue&type=style&index=0&id=d1c2ac84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports